<template>
  <div class="relative">
    <div class="text-text-label text-xs w-full mb-3-5" v-show="!!label">{{ label }}</div>
    <div class="flex items-center">
      <div class="flex items-center justify-center w-12 h-12
                border border-border rounded-full
                transition duration-200 cursor-pointer
                hover:border-border-hover"
           :class="previewDefaultClass"
           :style="previewStyle"
           @click="select = selected">
        <MKIcons :icon="selected" class="text-2sm" :class="previewIconClass"/>
      </div>
      <div class="text-xs text-text-label ml-4">
        <slot>Выберите иконку для счета</slot>
      </div>
    </div>
    <div v-if="select"
         class="icon-picker-popup space-y-10"
         v-on-click-away="hidePopup">
      <div class="grid grid-cols-12" v-for="(group,i) in groups" :key="i">
        <div class="text-sm text-text font-semibold mb-1 col-span-12 lg:col-span-2 lg:pt-2 ">
          {{ $t(group.title) }}
        </div>
        <div class="grid grid-cols-12 lg:grid-cols-icon-picker col-gap-2 row-gap-4
                    col-span-12 lg:col-span-10">
          <div v-for="(icon,j) in group.icons" :key="j"
               class="icon-preview"
               :class="{'selected':icon === selected && group.title !== 'BANKS',
                        'selected-bank':icon === selected && group.title === 'BANKS',
                        'p-3-3':group.title !== 'BANKS'}"
               @click="selectIcon(icon)">
            <MKIcons :icon="icon" class="flex items-center justify-center text-2sm"/>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {directive as onClickAway} from "vue-clickaway";
import {groups, isBankIcon} from "@/components/icons/MKIcons/icons";
import MKIcons from "@/components/icons/MKIcons/MKIcons";

export default {
  name: "IconPicker",
  components: {
    MKIcons,
  },
  directives: {
    onClickAway: onClickAway
  },
  props: {
    selected: {
      //should be valid to one icons in data ALWAYS
      // required:true,
    },
    label: {
      type: String
    },
    iconColor: {
      type: String,
      default: null
    },
    iconBg: {
      type: String,
      default: null
    }
  },
  data() {
    return {
      select: null,
      groups,
    }
  },
  computed: {
    previewIsBank() {
      return isBankIcon(this.selected);
    },
    previewIsDefault() {
      return this.previewIsBank || !this.iconBg;
    },
    previewDefaultClass() {
      return this.previewIsDefault ? 'bg-block' : '';
    },
    previewIconClass() {
      return this.previewIsDefault ? 'text-text-ternary' : '';
    },
    previewStyle() {
      if (this.previewIsDefault) return {};
      return {
        background: this.iconBg,
        color: this.iconColor || '#ffffff',
        borderColor: 'transparent'
      };
    }
  },
  methods: {
    selectIcon(icon) {
      this.$emit('change', icon);
      this.select = null;
    },
    hidePopup() {
      this.select = null
    }
  },
  i18n: {
    messages: {
      en: {
        'BANKS': 'Banks',
        'FINANCE': 'Finances',
        'CURRENCY': 'Currency',
        'PAYMENTS': 'Payments',
        'CRYPTO': 'Crypto',
        'SHOPPING': 'Shopping',
        'ALERTS': 'Alerts',
        'HOME & FAMILY': 'Home & family',
        'BUILDINGS': 'Buildings',
        'HOBBY & FUN': 'Hobby & fun',
        'OFFICE': 'Office',
        'TRANSPORT': 'Transport',
        'AUDIO / VIDEO': 'Audio / Video',
      },
      ru: {
        'BANKS': 'Банки',
        'FINANCE': 'Финансы',
        'CURRENCY': 'Валюта',
        'PAYMENTS': 'Платежи',
        'CRYPTO': 'Криптовалюта',
        'SHOPPING': 'Покупки',
        'ALERTS': 'Оповещения',
        'HOME & FAMILY': 'Дом и семья',
        'BUILDINGS': 'Строения',
        'HOBBY & FUN': 'Развлечения',
        'OFFICE': 'Офис',
        'TRANSPORT': 'Транспорт',
        'AUDIO / VIDEO': 'Аудио / видео',
      }
    }
  }
}
</script>

<style scoped lang="scss">
.icon-picker-popup {
  @apply absolute mt-4 -bottom-4 -left-2 transform translate-y-full z-100 bg-block shadow-primaryBlock rounded p-4 ;
  width: 500px;
  @media (min-width: 1230px) {
    width: 760px;
  }
}

.icon-preview {
  @apply flex items-center justify-center cursor-pointer relative
  rounded-full text-white bg-text-ternary
  transition duration-200;
  width: 2.4rem;
  height: 2.4rem;

  &:before {
    @apply absolute transition duration-200 rounded-full border border-transparent;
    content: '';
    width: calc(100% + 4px);
    height: calc(100% + 4px);
  }

  &:hover {
    @apply bg-icon-active;
    &:before {
      @apply border-icon-active;
    }
  }

  &.selected {
    @apply bg-green;
  }

  &.selected-bank:before {
    @apply border-green;
  }
}
</style>